import { inject, Injectable } from '@angular/core';
import {
  type CreateOrUpdateFeatureToggleInput,
  type CreateOrUpdateFeatureToggleMutationMutation,
  type CreateOrUpdateFeatureToggleMutationMutationVariables,
  type FeatureToggleFragment,
  type FeatureToggleQueryQuery,
  type FeatureToggleQueryQueryVariables,
} from '@reconcept-platform/shared/types';
import { gql } from 'apollo-angular';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedGraphQlService } from '../../services/shared-graphql.service';
import { featureToggleFragment } from './feature-toggle.fragments';

@Injectable({
  providedIn: 'root',
})
export class FeatureTogglesApi {
  private graphQlService = inject(SharedGraphQlService);

  watchFeatureToggles(active = false): Observable<FeatureToggleFragment[]> {
    return this.graphQlService
      .watchQuery<FeatureToggleQueryQuery, FeatureToggleQueryQueryVariables>({
        query: gql`
          query FeatureToggleQuery($onlyActive: Boolean) {
            featureToggles(onlyActive: $onlyActive) {
              nodes {
                ...FeatureToggle
              }
            }
          }
          ${featureToggleFragment}
        `,
        variables: {
          onlyActive: active,
        },
      })
      .pipe(map((result) => result.data.featureToggles.nodes));
  }

  updateFeatureToggle(input: CreateOrUpdateFeatureToggleInput) {
    return (
      this.graphQlService
        .mutateV2<CreateOrUpdateFeatureToggleMutationMutation, CreateOrUpdateFeatureToggleMutationMutationVariables>({
          mutation: gql`
            mutation CreateOrUpdateFeatureToggleMutation($input: CreateOrUpdateFeatureToggleInput!) {
              createOrUpdateFeatureToggle(input: $input) {
                errors {
                  message
                  path
                }

                featureToggle {
                  ...FeatureToggle
                }
              }
            }
            ${featureToggleFragment}
          `,
          variables: { input },
          update: (cache) => {
            cache.evict({ fieldName: 'featureToggles' });
            cache.gc();
          },
        })
        // @ts-expect-error TS18048 possibly undefined | TS18049 possibly null or undefined
        .pipe(map((result) => result.data.createOrUpdateFeatureToggle.featureToggle))
    );
  }
}
